const initialSharedState = {
  id: 1,
  sortSamples: 'NEWEST',
  collapseSubstitutions: false,
  viewAsReference: true
}

export default initialSharedState
